import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

export default class LightboxGallery extends Component {
  static propTypes = {
    onRequestClose: PropTypes.func,
    initialImageIndex: PropTypes.number,
    images: PropTypes.arrayOf([
      PropTypes.shape({
        url: PropTypes.string
      })
    ])
  };

  state = {
    currentImageIndex: 0
  };

  componentDidMount() {
    if (this.props.initialImageIndex) {
      this.setState({
        currentImageIndex: this.props.initialImageIndex
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.initialImageIndex !== this.props.initialImageIndex) {
      this.setState({
        currentImageIndex: this.props.initialImageIndex
      });
    }
  }

  render() {
    const { currentImageIndex } = this.state;
    const { images, onRequestClose, ...rest } = this.props;
    return (
      <Modal
        onRequestClose={onRequestClose}
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100vw',
            height: '100vh'
          },
          content: {
            overflow: 'unset',
            textAlign: 'center',
            border: 0,
            background: 'none',
            padding: 0,
            bottom: 'unset',
            top: 'unset',
            left: 'unset',
            right: 'unset'
          }
        }}
        {...rest}
      >
        <div
          onClick={onRequestClose}
          title="close"
          style={{
            position: 'absolute',
            right: -30,
            top: -30,
            padding: 10,
            color: '#fff'
          }}
        >
          ✕
        </div>
        <img
          style={{
            maxWidth: '80vw',
            maxHeight: '80vh',
            cursor: 'pointer'
          }}
          src={images[currentImageIndex].url}
          onClick={() =>
            this.setState({
              currentImageIndex: currentImageIndex === images.length - 1 ? 0 : currentImageIndex + 1
            })
          }
        />
      </Modal>
    );
  }
}
